import { ReactComponent as CloseIcon } from '@app/assets/x.svg';
import { ChampionPlanWithPriceButton } from '@app/domains/champion/components/ChampionPlanButtonOnly';
import ChampionPlanWithDialog from '@app/domains/champion/containers/ChampionPlanWithDialog';
import type { ChampionPurchaseDialogProps } from '@app/domains/champion/types';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

export default function ChampionPurchaseCompletedNovelDialog({
    on,
    novelId,
    novelName,
    activeChampionSubscription,
    championPlans,
    onClickSubscribePlan,
    onSubscribePlan,
    onClose,
}: ChampionPurchaseDialogProps) {
    const plan = championPlans[0];
    return (
        <>
            <Dialog
                open
                maxWidth={false}
                PaperProps={{
                    style: {
                        width: '100%',
                        maxWidth: '356px',
                        borderRadius: '12px',
                    },
                }}
            >
                <DialogTitle className="p-0">
                    <CloseIcon
                        onClick={onClose}
                        className="absolute right-8 top-8 inline-block cursor-pointer text-gray-400"
                    />
                </DialogTitle>
                <DialogContent className="py-24 px-0 overflow-x-hidden styled-scrollbar">
                    <div className="text-center" data-posthog-params={JSON.stringify({ on, novelId, novelName })}>
                        <div className="px-24 pt-32">
                            <div className="mb-12">
                                <h2 className="font-set-b26 text-gray-t1">{novelName}</h2>
                            </div>
                            <div className="mb-28 font-set-r16 whitespace-pre-line text-gray-t2">
                                <div>Become a Champion</div>
                                <div>and read all published chapters!</div>
                            </div>
                        </div>
                        <div className="px-16">
                            <ChampionPlanWithDialog
                                plan={plan}
                                currentSubscription={activeChampionSubscription ?? null}
                                onClickSubscribe={onClickSubscribePlan}
                                onSubscribePlan={onSubscribePlan}
                                renderChampionPlan={ChampionPlanWithPriceButton}
                            />
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}
